var addRemoveForm = (function() {

    var $modalType;
    var $container_id;
    var $is_extra;
    var $form_state;
    var $field_name;

  function init($btnModal) {

    $modalType = $btnModal.data('target');
    $container_id = $btnModal.closest('[data-id]').data('id');

    //Delete all datas in modal before loading
    $($modalType).find('.formulaire-objectif').html("");

    //Configurate the modal
    modalConfiguration($btnModal);

    // Handling form change.
    validateForm();

    // Bind the textareas to a onchange event
    $($modalType).find('textarea').keyup(function (e){
        validateForm();
    });

    // On submit, validate the form
    $('#objective-form').submit(function(e){
        e.preventDefault();

        if(validateForm() == true){
            e.currentTarget.submit();
        }
    });
  };

  function modalConfiguration($btnModal){

      //Change Title
      var title = $btnModal.data('title');
      $('#objective-modal-title').html(title);

      //Add URL to form
      var url = $btnModal.data('url');
      $('#objective-form').attr('action', url);

      $form_state = $btnModal.data('state');
      $field_name = $btnModal.data('field');
      if($form_state == 'add-objective'){
          $('.btn-delete').addClass('d-none');

          $($modalType).find('.formulaire-objectif').append($("#template-objectives").html());
          $($modalType).find('#issue_id').val($container_id);

          addAction($modalType);
      }else if($btnModal.data('state') == 'edit-objective'){
          //See if the edit modal refers to a custom goal
          $is_extra = $btnModal.data('isextra');

         if($is_extra == "True"){
            $('.btn-delete').removeClass('d-none');

              //Bind delete action to the delete button
              var deleteGoal = $btnModal.data('delete');
              $('.btn-delete').data('action', deleteGoal);
        }else{
            $('.btn-delete').addClass('d-none');
        }


          $.ajax({
             type: 'GET',
             url: url,
             dataType:'html',
             success: function(data){
                  $($modalType).find('.formulaire-objectif').append($(data).find('.action').prop('outerHTML'));
                   var issues = $($modalType).find('textarea');

                   validateForm();

                  //Bind the new textarea to an onchange event
                  $(issues).keyup(function (e){
                      validateForm();
                  });

                  addAction($modalType);
             },
         });
      }
  }

  function addAction($modalType){
      var $btnAddOpportunity = $('.formulaire-objectif .add-action');

      $($btnAddOpportunity).click(function(){
          $(this).parent().children('.group').last().append($("#template-actions").html());
          validateForm();
          updateActions();
      });
  }

  function removeAction($this){

      //Remove if not disabled
      if(!$($this).hasClass('disabled')){
          $($this).closest('.item').remove();
      }
      updateActions();
      validateForm();
  }

  function deleteGoal($this){
      var url = $($this).data('action');

      if(url){
          $('#objective-form').attr('action', url);
          $('#objective-form').submit();
      }
  }

  function disableAction($this){
      //Check the checkbox
      $($this).siblings('input[type="checkbox"]').prop('checked', true);

      //Hide the field
      $($this).closest('.item').hide();
  }

  function updateActions(){
      var actions = $($modalType).find('.sub-checkboxes .extra_actions .custom-edit textarea');

      var prefix;

      if($form_state == "edit-objective"){
          prefix = $container_id + '-extra-';
      }else{
          prefix = 'action-';
      }

      $($modalType).find('#id_'+ prefix +'TOTAL_FORMS').val(actions.length);
      var i;
      for (i = 0; i < actions.length; i++){
          actions.eq(i).attr('name', prefix + i + '-' + $field_name);
          actions.eq(i).attr('id', 'id_' + prefix + i + '-' + $field_name);

          //Bind the new textarea to an onchange event
          $(actions).keyup(function (e){
              validateForm();
          });
      }
  }

  function validateForm(){
        var opportunitiesNb = $($modalType).find('.group.countable .custom-edit').length;
        var textareas = $($modalType).find('.countable textarea');

        var fieldsEmpty = false;


        textareas.each(function(){
            if($(this).val().length <= 0){

                if(!$(this).attr('placeholder')){
                    fieldsEmpty = true;
                }
            }
        });

        if(opportunitiesNb > 0 && fieldsEmpty == false){
            $('[data-action="saveGoal"]').removeClass('disabled');
            return true;
        }else{
            $('[data-action="saveGoal"]').addClass('disabled');
            return false;
        }
  }

  return {
      init: init,
      removeAction: removeAction,
      disableAction: disableAction,
      deleteGoal: deleteGoal
  }
})();
